"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyActivityViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class EmptyActivityViewModel extends ActivityViewModel_1.ActivityViewModel {
    constructor(emptyActivity, processModel) {
        super(emptyActivity, processModel);
        this.enabled = emptyActivity.enabled;
    }
}
exports.EmptyActivityViewModel = EmptyActivityViewModel;
//# sourceMappingURL=EmptyActivityViewModel.js.map